/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<ObjectMap>;
export function request(
  body: defs.basics.PlmMaterialCategoryRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/plmMaterialCategory/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
